import { SelectListItem } from '@shared/models/select-list-item';
import { Dayjs } from 'dayjs';
import { DateRange as MatDateRange } from '@angular/material/datepicker';
import { getTimeZones } from '@vvo/tzdb';

export const AVAILABLE_DATERANGE_MODIFIERS = ['day', 'week', 'month', 'quarter', 'year'] as const;
export type DaterangeModifier = (typeof AVAILABLE_DATERANGE_MODIFIERS)[number];

export const DATERANGE_MODIFIER_OPTIONS: Array<SelectListItem<DaterangeModifier>> = AVAILABLE_DATERANGE_MODIFIERS.filter(
  mod => mod !== 'day',
).map(mod => ({
  value: mod,
  name: mod.charAt(0).toUpperCase() + mod.slice(1),
}));

export type DateRange = MatDateRange<Dayjs>;
export type PresetId = 'this' | 'last' | 'toDate' | 'custom';
export type Preset = { id: PresetId; modifier?: DaterangeModifier };

export const AVAILABLE_TIMEZONE_OPTIONS: SelectListItem[] = getTimeZones({ includeUtc: true }).map(tz => ({
  name: `GMT${tz.rawFormat}`,
  value: tz.name,
}));
